import React, { useEffect, useState } from 'react';
import logo from '../../../assets/owlbot_logo_login.png';
import Footer from '../../../components/Footer/Footer';
import axios from 'axios';

import { Link } from 'react-router-dom';

const EmailVerification = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get('token');
  const userId = queryParameters.get('userId');
  const [state, setstate] = useState(false);
  const [response, setResponse] = useState('');

  useEffect(() => {
    userVerification();
  }, []);

  const userVerification = async () => {
    const obj = {
      verifiedToken: token,
      userId: userId,
    };
    await axios
      .post(`${process.env.REACT_APP_API_BASEURL}/account/verify-email`, obj)
      .then((response) => {
        if (response.status === 200) {
          setResponse(response.data.message);
          setstate(true);
        }
      })
      .catch((err) => {
        setResponse(err.response.data.Message);
      });
  };
  return (
    <>
      <div className=" relative flex flex-col  justify-center items-center h-screen bg-slate-100">
        <div className="border w-96 h-[400] p-8 flex flex-col justify-center shadow-lg rounded-sm bg-white">
          <div className="w-72 h-[400] flex flex-col justify-center  text-center mx-auto rounded">
            <img src={logo} className="w-9/12 mx-auto my-0 " />

            <div className="py-3">
              <div className="text-3xl pb-2">
                {state ? (
                  <i className="fa-solid text-[50px] fa-envelope-circle-check text-[green]"></i>
                ) : (
                  <i className="fa-solid fa-ban text-[50px] text-[red]"></i>
                )}
                <div className="text-[14px]">{response}</div>
              </div>
            </div>
          </div>
          <Link
            to={'/'}
            className="text-center text-blue-800 text-sm cursor-pointer hover:underline"
          >
            Back to login
          </Link>
        </div>
        <div className="absolute right-0 bottom-0">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default EmailVerification;
